import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsTop() {
  const testimonials = [{
    initials: 'MG',
    name: 'Martín G.',
    location: 'Córdoba',
    quote: 'Tenía el scooter parado hace 3 semanas. Con el eBook de fallas lo diagnostiqué en 20 minutos y lo arreglé yo mismo.'
  }, {
    initials: 'LP',
    name: 'Lucas P.',
    location: 'Rosario',
    quote: 'El eBook de mantenimiento preventivo me salvó. Antes gastaba una fortuna en service. Ahora lo hago yo.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    quote: 'El desarme paso a paso es increíble. Por fin entendí cómo funciona todo sin romper nada.'
  }];
  return <section className="py-16 px-4" data-id="element-307">
      <div className="max-w-6xl mx-auto" data-id="element-308">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-309">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-surface border border-border rounded-2xl p-6 hover:border-brand/30 transition-colors" data-id="element-310">
              <div className="flex items-center gap-4 mb-4" data-id="element-311">
                <div className="w-12 h-12 rounded-full bg-brand/10 text-brand flex items-center justify-center font-bold text-lg" data-id="element-312">
                  {t.initials}
                </div>
                <div data-id="element-313">
                  <div className="font-bold text-white" data-id="element-314">{t.name}</div>
                  <div className="text-sm text-muted" data-id="element-315">{t.location}</div>
                </div>
              </div>
              <div className="flex gap-1 mb-3" data-id="element-316">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-accent text-accent" data-id="element-317" />)}
              </div>
              <p className="text-gray-300 italic" data-id="element-318">"{t.quote}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}